module.exports = __webpack_public_path__ + "static/img/gxdw.ed54ccce.png";